import { Controller } from "@hotwired/stimulus"
import { useHotkeys } from "stimulus-use/hotkeys"

// Closing a picker is going back to the page underneath, so Escape does exactly
// what the × does: follows the same link, through whatever frame the picker was
// opened in, which is what keeps the page where the reader left it.
export default class extends Controller {
  static targets = ["close"]

  connect() {
    useHotkeys(this, { esc: [this.close] })
  }

  close() {
    this.closeTarget.click()
  }
}
